import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { List, X } from "@phosphor-icons/react";
import { images, navLinks } from "@/data/site";

function linkClass(pathname, href) {
  const active = href === "/" ? pathname === "/" : !href.includes("#") && pathname.startsWith(href);
  return `font-mono text-xs uppercase tracking-[0.18em] transition-colors hover:text-industrial-yellow ${active ? "text-industrial-yellow" : "text-industrial-muted"}`;
}

export function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-industrial-line bg-white/90 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-20 max-w-[1500px] items-center justify-between px-5 sm:px-8">
        <Link to="/" className="flex items-center gap-3" data-testid="header-home-logo-link" aria-label="Shyam Equipment and Infratech home">
          <img src={images.logo} alt="Shyam Equipment and Infratech" className="h-11 w-auto object-contain sm:h-12" />
          <span className="hidden border-l border-industrial-line pl-3 font-mono text-[10px] uppercase leading-4 tracking-[0.22em] text-industrial-muted xl:block">
            PAN India<br />Project Support
          </span>
        </Link>
        <nav className="hidden items-center gap-6 lg:flex" aria-label="Primary navigation">
          {navLinks.map((link) => (
            <Link key={link.href} to={link.href} data-testid={link.testId} className={linkClass(pathname, link.href)}>
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/contact" data-testid="header-get-quote-button" className="group hidden items-center gap-2 border border-industrial-yellow bg-industrial-yellow px-5 py-3 font-mono text-xs font-bold uppercase tracking-[0.18em] text-industrial-black transition-colors hover:bg-transparent hover:text-industrial-yellow sm:flex">
            Get a Quote <span aria-hidden="true" className="text-sm leading-none transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5">↗</span>
          </Link>
          <button type="button" data-testid="mobile-menu-toggle-button" onClick={() => setOpen(!open)} className="flex h-11 w-11 items-center justify-center border border-industrial-line text-industrial-text lg:hidden" aria-label="Toggle navigation menu">
            {open ? <X size={22} weight="bold" /> : <List size={22} weight="bold" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden border-t border-industrial-line bg-white lg:hidden" data-testid="mobile-navigation-menu">
            <div className="grid px-5 py-4">
              {navLinks.map((link) => (
                <Link key={link.href} to={link.href} data-testid={`mobile-${link.testId}`} onClick={() => setOpen(false)} className="border-b border-industrial-line py-4 font-heading text-2xl font-semibold uppercase text-industrial-text last:border-0">
                  {link.label}
                </Link>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
